import { config } from 'dotenv';
import abi from './contracts/ChainOfEvents.json';

config();

const { REACT_APP_API, REACT_APP_ETHERSCAN, REACT_APP_CONTRACT_ADDRESS, REACT_APP_CONTRACT_GAS, REACT_APP_NETWORK } = process.env;

/**
 * @name CONFIG
 * @constant
 * @object
 * @description Configuration for requests
 */
const CONFIG = {
    api: REACT_APP_API,
    contract: {
        abi,
        address: REACT_APP_CONTRACT_ADDRESS,
        gasPrice: REACT_APP_CONTRACT_GAS
    },
    etherscan: REACT_APP_ETHERSCAN,
    network: REACT_APP_NETWORK
}

export default CONFIG;